/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerGetConversationHistoryQueryResponse, MultiDocumentAgentControllerGetConversationHistoryPathParams, MultiDocumentAgentControllerGetConversationHistoryQueryParams, MultiDocumentAgentControllerGetConversationHistory401, MultiDocumentAgentControllerGetConversationHistory403 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerGetConversationHistory";

function getMultiDocumentAgentControllerGetConversationHistoryUrl(threadId: MultiDocumentAgentControllerGetConversationHistoryPathParams["threadId"]) {
  const res = { method: 'GET', url: `/api/v1/multi-document-agent/history/${threadId}` as const }  
  return res
}

/**
 * @description Returns conversation history grouped by question-answer pairs with thinking steps
 * @summary Get grouped conversation history for a thread
 * {@link /api/v1/multi-document-agent/history/:threadId}
 */
export async function multiDocumentAgentControllerGetConversationHistory(threadId: MultiDocumentAgentControllerGetConversationHistoryPathParams["threadId"], params?: MultiDocumentAgentControllerGetConversationHistoryQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerGetConversationHistoryQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerGetConversationHistory401 | MultiDocumentAgentControllerGetConversationHistory403>, unknown>({ method : "GET", url : getMultiDocumentAgentControllerGetConversationHistoryUrl(threadId).url.toString(), params, ... requestConfig })  
  return res.data
}